import React from 'react';
import { LoaderStyles } from "../../styles";

export const Loader = () => {
    const classes = LoaderStyles();
    return (<div id="preload" className={classes["load-container"]}>
        <div className={classes["load"]}>
        <hr/><hr/><hr/><hr/>
        </div>
    </div>)
}